// @flow

import _ from 'lodash'

export function getDisplayName(displayName: string) {
  // display name is escaped at the service layer but React escapes strings by default
  // so this string ends up getting double escaped and does not get displayed properly
  return _.unescape(displayName)
}
